module.exports = __webpack_public_path__ + "Sailec-Bold.55e70b92a8a9277dc6c3.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/Sailec-Bold/Sailec-Bold.ttf
// module id = ../../../../../src/assets/fonts/Sailec-Bold/Sailec-Bold.ttf
// module chunks = styles